module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('spinner') : _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.error) ? _c('div', {
    staticClass: "container"
  }, [_c('force-league-update', {
    attrs: {
      "summoner": _vm.summoner
    }
  }), _vm._v(" "), _c('summoner-banner', {
    attrs: {
      "summoner": _vm.summoner
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, [_c('div', {
    staticClass: "column is-12-tablet is-5-desktop"
  }, [(_vm.dailyDifferences.length) ? _c('gain-loss-graph', {
    attrs: {
      "differences": _vm.dailyDifferences
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-12-tablet is-7-desktop"
  }, [(!_vm.hasLeaguePositions) ? _c('div', {
    staticClass: "box box--highlight",
    staticStyle: {
      "padding-top": "2rem",
      "padding-bottom": "2rem"
    }
  }, [_c('h2', {
    staticClass: "title is-4 is-primary",
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_vm._v("No tracked " + _vm._s(_vm.queueName) + " queue games")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n              The summoner just got added to the system or hasn't played any ranked games yet."), _c('br')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Come back later!")])])])]) : _vm._e(), _vm._v(" "), (_vm.hasLeaguePositions) ? _c('div', {
    staticClass: "league-positions"
  }, [_vm._l((_vm.leaguePositions), function(leaguePosition) {
    return _c('league-position', {
      key: leaguePosition.id,
      attrs: {
        "league-position": leaguePosition
      }
    })
  }), _vm._v(" "), _c('paginator', {
    attrs: {
      "paginator": _vm.leaguePositionsPaginator,
      "loading": _vm.paginatorLoading
    },
    on: {
      "loadMoreItems": _vm.loadMoreItems
    }
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-12"
  }, [(_vm.leaguePointsHistory.length > 1) ? _c('league-points-history-graph', {
    attrs: {
      "history": _vm.leaguePointsHistory
    }
  }) : _vm._e()], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "container"
  }, [(_vm.errorDetails.status === 404) ? _c('div', {
    staticClass: "box box--error"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-narrow"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tier-icons/challenger.png"),
      "alt": "error image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "title is-5 is-danger"
  }, [_vm._v("Could not find the summoner!")]), _vm._v(" "), _c('p', [_vm._v("Didn't find the summoner "), _c('strong', [_vm._v(_vm._s(_vm.errorDetails.response.name) + " @ " + _vm._s(_vm.errorDetails.response.region.name))]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Please check the spelling and the region.")]), _vm._v(" "), _c('summoner-search', {
    staticStyle: {
      "margin-top": "1.5rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content is-small",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_c('p', [_vm._v("The search is "), _c('strong', [_vm._v("not")]), _vm._v(" case sensitive.")])])], 1)])]) : _c('div', {
    staticClass: "box box--error"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-narrow"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tier-icons/bronze.png"),
      "alt": "error image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "title is-5 is-danger"
  }, [_vm._v("The server responded with an error!")]), _vm._v(" "), _c('p', [_vm._v("Please try it again.")]), _vm._v(" "), _c('summoner-search', {
    staticStyle: {
      "margin-top": "1.5rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content is-small",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_c('p', [_vm._v("The search is "), _c('strong', [_vm._v("not")]), _vm._v(" case sensitive.")])])], 1)])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b38f699","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Summoner.vue
// module id = 401
// module chunks = 1